import React from 'react';
import { StyledVoiceoverChromakey } from './VoiceoverChromakey.styled';
import { Toggle } from '../';

const VoiceoverChromakey = ({ showGreenScreen, onToggleGreenScreen }) => {
  return (
    <StyledVoiceoverChromakey>
      <div className='voiceover-chromakey-content-wrapper'>
        <div className='voiceover-chromakey-content'>
	  <div className='voiceover-chromakey-option-row'>
	    <div className='voiceover-chromakey-option-title'>Green Screen</div>
	    <Toggle value={showGreenScreen} onToggle={onToggleGreenScreen} />
	  </div>
	</div>
      </div>
      {/*<div className='voiceover-powered-by'>
        <span className='voiceover-powered-by-label'>Powered By</span>
        <span className='voiceover-elevenlabs-logo'>llElevenLabs</span>
      </div>*/}
      <div className='voiceover-chromakey-corner voiceover-chromakey-corner-tl' />
      <div className='voiceover-chromakey-corner voiceover-chromakey-corner-tr' />
      <div className='voiceover-chromakey-corner voiceover-chromakey-corner-bl' />
      <div className='voiceover-chromakey-corner voiceover-chromakey-corner-br' />
    </StyledVoiceoverChromakey>
  )
};

export default VoiceoverChromakey;
